/* eslint-disable react-refresh/only-export-components */
import './index.css';

import * as Sentry from '@sentry/react';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router/dom';

import { FallbackComponent } from './components';
import { theme } from './config/theme';
import { router } from './router';
import { store } from './state';

/**
 * Initialize Sentry error tracking
 * - Only enabled in production builds
 * - Tracks 100% of transactions for debugging
 */
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 1.0,
  environment: 'production', // "development" | "production"
});

/**
 * Lazy-loaded configuration components
 * - Split from main bundle for better performance
 * - Loaded asynchronously during runtime
 */
const ConfigLoader = lazy(() =>
  import('./config').then(({ ConfigLoader: Component }) => ({
    default: Component,
  }))
);
const CommonLoader = lazy(() =>
  import('./components').then(({ CommonLoader: Component }) => ({
    default: Component,
  }))
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
    <Provider store={store}>
      <ConfigProvider locale={enUS} theme={theme}>
        <Suspense fallback={<FallbackComponent requesting />}>
          <ConfigLoader />
          <CommonLoader />
          <RouterProvider router={router} />
        </Suspense>
      </ConfigProvider>
    </Provider>
  </Sentry.ErrorBoundary>
);
